import { render, staticRenderFns } from "./LogsArchiveHistoryPageComponent.vue?vue&type=template&id=4935b912"
import script from "./LogsArchiveHistoryPageComponent.vue?vue&type=script&lang=js"
export * from "./LogsArchiveHistoryPageComponent.vue?vue&type=script&lang=js"
import style0 from "./LogsArchiveHistoryPageComponent.vue?vue&type=style&index=0&id=4935b912&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports